import heroServerArtwork from '../assets/hero-isometric-servers.png';

export const SHARED_STOREFRONT_CONTENT_KEY = 'cloudsetu_shared_storefront_content';

const clone = value => JSON.parse(JSON.stringify(value));
const LEGACY_COPY = {
  'SHARED HOSTING': 'Your next idea deserves a better home.',
  'Shared Hosting': 'Cloud hosting, made simpler',
  'Get Started': 'Explore hosting',
  'Know More': 'Talk to our team',
  'Share processes and data securely on a need to know basis without the need for reconciliation it combines a permissione.': 'Launch and manage your hosting business with a flexible platform, clear tools, and a team ready to help you move forward.',
  'WHY CHOOSE US': 'The right tools, without the extra complexity.',
  'Share processes and data secure on a need to know basis.': 'Bring the essentials together and spend more time building your business.',
  '99.9% Uptime Guarantee': 'A smoother workflow',
  'Share processes and data secure on a need to know basis.': 'Manage the everyday work of hosting from one clear, connected experience.',
  'Safe and Secured': 'Security-minded by design',
  'Our team assured your web site is always safe and secure.': 'Give your team practical controls for managing accounts and services.',
  'Our Dedicated Support': 'People when you need them',
  'We finally found a host that truly understood the unique needs of our infrastructure.': 'Get guidance from a team that understands hosting operations.',
  'Everything you need to succeed': 'Everything you need to run hosting with confidence.',
  'Enterprise-grade infrastructure, automated orchestration, and 24/7 expert support.': 'A practical toolkit for managing services, customers, and your storefront as your business grows.',
  'Fast Performance': 'Service management',
  'Ultra-low latency NVMe storage and global CDN.': 'Keep hosting products and customer accounts organized.',
  '99.99% Uptime SLA': 'Manage service plans',
  'Global Edge CDN': 'Track customer activity',
  'Auto Scaling': 'Keep key details together',
  'Secure Cloud': 'A branded storefront',
  'Enterprise-grade firewall and automated protection.': 'Present your hosting business with a consistent customer experience.',
  'Daily Backups': 'Use your brand identity',
  'Free SSL': 'Choose a storefront layout',
  'Isolated Containers': 'Preview before publishing',
  'Expert Support': 'Room to grow',
  '24/7 dedicated engineering support.': 'Build your workflow around the way your team works today.',
  'Live Chat': 'Start with core services',
  'Account Manager': 'Add content as you grow',
  'Fast SLA': 'Get help from our team',
  'Trusted by over 10,000 businesses': 'Stories from teams building what is next.',
  'Discover how top companies accelerated their digital infrastructure with our platform.': 'See how hosting businesses shape a customer experience that works for them.',
  'Reliable from day one': 'A better customer journey',
  'Excellent service and support.': 'Add an approved customer quote about the experience of getting started.',
  'Aarav Mehta': 'Customer name',
  'Founder': 'Company',
  'A team we can trust': 'Tools that fit the work',
  'The platform helped us scale with confidence.': 'Add a verified story about how your platform supports a hosting team.',
  'Priya Sharma': 'Customer name',
  'CTO': 'Company',
  'Outstanding performance': 'Support that feels close',
  'Our workloads are faster and easier to manage.': 'Add an approved quote describing a real customer support experience.',
  'Daniel Lee': 'Customer name',
  'Operations Lead': 'Company',
  'Powering innovative brands worldwide': 'Built around the details that matter.',
  'Industry-leading security, 99.99% uptime guarantee, and SOC2 certified compliance.': 'A thoughtful service experience, dependable communication, and practical tools for your team.',
  '99.99%': 'Clear workflows',
  'Uptime SLA': 'Keep everyday tasks organized.',
  'SOC 2': 'Your brand',
  'Certified security': 'Create a consistent storefront.',
  '24/7': 'Human support',
  'Expert support': 'Get guidance from real people.',
  'Frequently asked questions': 'Questions? Start here.',
  'Everything you need to know before launching with CloudSetu.': 'A few helpful details about getting started and managing your storefront.',
  'How quickly can I launch?': 'How do I get started?',
  'Your storefront can be configured and published in minutes.': 'Tell us about your hosting business and goals. Our team can walk you through the setup options.',
  'Can I connect a custom domain?': 'Can I use my own brand?',
  'Yes, custom domains and SSL setup are supported.': 'Yes. The white-label experience is designed to present your business identity across the storefront.',
  'Can I change colors and content?': 'Can I update my storefront later?',
  'Use the branding and rich text controls to update the full page.': 'You can manage your content and layout in the builder and preview changes before publishing.',
  'Latest from our blog': 'Ideas for your next move.',
  'Cloud insights, hosting guides, and product updates from our team.': 'Practical perspectives on hosting, customer experience, and growing a digital business.',
  'Scaling cloud infrastructure': 'Planning your hosting offer',
  'A practical guide to growing infrastructure safely.': 'A useful framework for shaping services around the customers you want to serve.',
  'Securing every workload': 'A clearer customer onboarding journey',
  'Best practices for protecting modern hosting stacks.': 'Small improvements that can make the first steps feel easier for new customers.',
  'Building a reseller storefront': 'Building a storefront around your brand',
  'How to launch a white-label hosting experience.': 'Ways to make a digital storefront feel consistent, useful, and distinctly yours.',
  'Discover what is possible': 'A platform that moves with your business.',
  'Create a memorable experience with fully editable slides.': 'Explore the building blocks for a more connected hosting experience.',
  'Scale without limits': 'Bring your services together',
  'Deploy globally distributed infrastructure in minutes.': 'Present your hosting offer in one place with a storefront built around your brand.',
  'Security at every layer': 'Make the customer journey yours',
  'Protect workloads with managed firewalls, backups, and SSL.': 'Shape your content and layout to fit the way your customers discover your services.',
  'Explore Now': 'Explore the platform',
  'CloudSetu Technologies': 'CloudSetu',
  'Next-generation cloud infrastructure and reseller storefront platform.': 'Tools and support for building a hosting business around your brand.',
  'About us\nContact\nCareers': 'About us\nContact\nPrivacy',
  'Documentation\nSupport\nStatus': 'Guides\nFAQs\nGet support',
  'Privacy\nTerms\nSecurity': 'Platform\nStorefronts\nServices',
  'Ready to launch your platform today?': 'Let’s build a better hosting experience.',
  'Join thousands of developers and businesses. Start your 14-day free trial with zero setup fees.': 'Tell us what you want to create. We will help you explore the right next step for your business.',
  'Start Free Trial': 'Talk to our team',
};

const migrateLegacyCopy = value => {
  if (typeof value === 'string') return LEGACY_COPY[value] || value;
  if (Array.isArray(value)) return value.map(migrateLegacyCopy);
  if (value && typeof value === 'object') return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, migrateLegacyCopy(item)]));
  return value;
};

export const DEFAULT_SHARED_STOREFRONT_CONTENT = {
  header: {
    navigation: [
      { label: 'Platform', href: '#features' },
      { label: 'Plans', href: '#pricing' },
      { label: 'FAQs', href: '#faq' },
    ],
    actions: [
      { label: 'Get in touch', href: '#contact', style: 'primary' },
    ],
    cards: [],
  },
  hero: {
    kicker: 'Cloud hosting, made simpler',
    heading: 'Your next idea deserves a better home.',
    subtext: 'Launch and manage your hosting business with a flexible platform, clear tools, and a team ready to help you move forward.',
    primaryText: 'Explore hosting',
    primaryUrl: '#features',
    secondaryText: 'Talk to our team',
    secondaryUrl: '#contact',
    mediaUrl: heroServerArtwork,
    mediaAlt: 'Isometric cloud server network',
    cards: [],
  },
  'why-us': {
    kicker: 'A better way to host',
    heading: 'The right tools, without the extra complexity.',
    subtext: 'Bring the essentials together and spend more time building your business.',
    primaryText: 'Explore All Features',
    cards: [
      { icon: '⚡', title: 'A smoother workflow', text: 'Manage the everyday work of hosting from one clear, connected experience.', linkText: 'Explore the platform' },
      { icon: '🛡️', title: 'Security-minded by design', text: 'Give your team practical controls for managing accounts and services.', linkText: 'See how it works' },
      { icon: '💬', title: 'People when you need them', text: 'Get guidance from a team that understands hosting operations.', linkText: 'Meet our team' },
    ],
  },
  features: {
    heading: 'Everything you need to run hosting with confidence.',
    subtext: 'A practical toolkit for managing services, customers, and your storefront as your business grows.',
    primaryText: 'Explore Features',
    cards: [
      { icon: '⚡', title: 'Service management', text: 'Keep hosting products and customer accounts organized.', list: ['Manage service plans', 'Track customer activity', 'Keep key details together'] },
      { icon: '🛡️', title: 'A branded storefront', text: 'Present your hosting business with a consistent customer experience.', list: ['Use your brand identity', 'Choose a storefront layout', 'Preview before publishing'] },
      { icon: '👑', title: 'Room to grow', text: 'Build your workflow around the way your team works today.', list: ['Start with core services', 'Add content as you grow', 'Get help from our team'] },
    ],
  },
  pricing: {
    kicker: 'Flexible options',
    heading: 'A plan that fits your next step.',
    subtext: 'Tell us what you are building. We will help you find the right setup for your team.',
    primaryText: 'Discuss your requirements',
    cards: [
      { title: 'Launch', price: 'Let’s talk', period: '', text: 'A straightforward starting point for a new hosting business.', list: ['Core storefront setup', 'Essential service workflows', 'Guided onboarding'], featured: false },
      { title: 'Growth', price: 'Let’s talk', period: '', text: 'More flexibility for teams serving a growing customer base.', list: ['Expanded storefront options', 'Flexible content management', 'Priority guidance'], featured: true },
      { title: 'Scale', price: 'Let’s talk', period: '', text: 'A tailored conversation for established or specialist teams.', list: ['Requirements-led setup', 'Dedicated planning', 'Custom service discussion'], featured: false },
    ],
  },
  testimonials: {
    heading: 'Stories from teams building what is next.',
    subtext: 'See how hosting businesses shape a customer experience that works for them.',
    primaryText: 'Read Stories',
    cards: [
      { title: 'A better customer journey', text: 'Add an approved customer quote about the experience of getting started.', author: 'Customer name', role: 'Company' },
      { title: 'Tools that fit the work', text: 'Add a verified story about how your platform supports a hosting team.', author: 'Customer name', role: 'Company' },
      { title: 'Support that feels close', text: 'Add an approved quote describing a real customer support experience.', author: 'Customer name', role: 'Company' },
    ],
  },
  trust: {
    heading: 'Built around the details that matter.',
    subtext: 'A thoughtful service experience, dependable communication, and practical tools for your team.',
    primaryText: '',
    cards: [
      { title: 'Clear workflows', text: 'Keep everyday tasks organized.' },
      { title: 'Your brand', text: 'Create a consistent storefront.' },
      { title: 'Human support', text: 'Get guidance from real people.' },
    ],
  },
  faq: {
    heading: 'Questions? Start here.',
    subtext: 'A few helpful details about getting started and managing your storefront.',
    primaryText: 'View All FAQs',
    cards: [
      { question: 'How do I get started?', answer: 'Tell us about your hosting business and goals. Our team can walk you through the setup options.' },
      { question: 'Can I use my own brand?', answer: 'Yes. The white-label experience is designed to present your business identity across the storefront.' },
      { question: 'Can I update my storefront later?', answer: 'You can manage your content and layout in the builder and preview changes before publishing.' },
    ],
  },
  blog: {
    heading: 'Ideas for your next move.',
    subtext: 'Practical perspectives on hosting, customer experience, and growing a digital business.',
    primaryText: 'View All Articles',
    cards: [
      { title: 'Planning your hosting offer', category: 'Business', date: 'Insights', summary: 'A useful framework for shaping services around the customers you want to serve.' },
      { title: 'A clearer customer onboarding journey', category: 'Customer experience', date: 'Guides', summary: 'Small improvements that can make the first steps feel easier for new customers.' },
      { title: 'Building a storefront around your brand', category: 'Product', date: 'Ideas', summary: 'Ways to make a digital storefront feel consistent, useful, and distinctly yours.' },
    ],
  },
  slider: {
    heading: 'A platform that moves with your business.',
    subtext: 'Explore the building blocks for a more connected hosting experience.',
    primaryText: 'Explore the platform',
    cards: [
      { icon: '☁️', title: 'Bring your services together', text: 'Present your hosting offer in one place with a storefront built around your brand.', buttonText: 'Explore storefronts' },
      { icon: '🔐', title: 'Make the customer journey yours', text: 'Shape your content and layout to fit the way your customers discover your services.', buttonText: 'See the platform' },
    ],
  },
  cta: {
    heading: 'Let’s build a better hosting experience.',
    subtext: 'Tell us what you want to create. We will help you explore the right next step for your business.',
    primaryText: 'Talk to our team',
    primaryUrl: '#contact',
    cards: [],
  },
  footer: {
    heading: 'CloudSetu',
    subtext: 'Tools and support for building a hosting business around your brand.',
    primaryText: 'Contact Us',
    cards: [
      { title: 'Explore', text: 'Platform\nStorefronts\nServices' },
      { title: 'Resources', text: 'Guides\nFAQs\nGet support' },
      { title: 'Company', text: 'About us\nContact\nPrivacy' },
    ],
  },
  products: {
    kicker: 'What We Offer',
    heading: 'Our Products & Services',
    subtext: 'Choose from our range of cloud services and SaaS solutions tailored for your business.',
    primaryText: 'Get Started',
    cards: [],
  },
};

export const normalizeSharedStorefrontContent = value => {
  const source = value && typeof value === 'object' ? value : {};
  return Object.fromEntries(Object.entries(DEFAULT_SHARED_STOREFRONT_CONTENT).map(([type, defaults]) => {
    const saved = source[type] && typeof source[type] === 'object' ? migrateLegacyCopy(source[type]) : {};
    const savedMediaUrl = typeof saved.mediaUrl === 'string' ? saved.mediaUrl : '';
    const usesBundledHeroArtwork = /(?:^|\/)assets\/images\/hero-isometric-servers\.png(?:[?#].*)?$/.test(savedMediaUrl);
    return [type, {
      ...defaults,
      ...saved,
      heading: typeof saved.heading === 'string' ? saved.heading : defaults.heading,
      subtext: typeof saved.subtext === 'string' ? saved.subtext : defaults.subtext,
      primaryText: typeof saved.primaryText === 'string' ? saved.primaryText : defaults.primaryText,
      mediaUrl: savedMediaUrl && !usesBundledHeroArtwork ? savedMediaUrl : defaults.mediaUrl,
      mediaAlt: typeof saved.mediaAlt === 'string' ? saved.mediaAlt : defaults.mediaAlt,
      cards: Array.isArray(saved.cards) ? clone(saved.cards) : clone(defaults.cards),
      navigation: Array.isArray(saved.navigation) ? clone(saved.navigation) : clone(defaults.navigation || []),
      actions: Array.isArray(saved.actions) ? clone(saved.actions) : clone(defaults.actions || []),
    }];
  }));
};

export const readSharedStorefrontContent = () => {
  try {
    return normalizeSharedStorefrontContent(JSON.parse(localStorage.getItem(SHARED_STOREFRONT_CONTENT_KEY) || 'null'));
  } catch {
    return normalizeSharedStorefrontContent(null);
  }
};

export const applySharedStorefrontContent = (sections, content) => {
  const shared = normalizeSharedStorefrontContent(content);
  return (Array.isArray(sections) ? sections : []).map(section => {
    const sharedSection = shared[section.type];
    if (!sharedSection) return section;
    const nextSection = {
      ...section,
      heading: sharedSection.heading,
      kicker: sharedSection.kicker,
      subtext: sharedSection.subtext,
      primaryText: sharedSection.primaryText,
      secondaryText: sharedSection.secondaryText,
      mediaUrl: sharedSection.mediaUrl,
      mediaAlt: sharedSection.mediaAlt,
      cards: clone(sharedSection.cards),
      navigation: clone(sharedSection.navigation || []),
      actions: clone(sharedSection.actions || []),
    };
    if (Object.prototype.hasOwnProperty.call(sharedSection, 'inlineTextEdits')) {
      delete nextSection.inlineTextEditsByVariant;
      nextSection.inlineTextEdits = { ...sharedSection.inlineTextEdits };
    }
    return nextSection;
  });
};
